<script setup lang="ts">


import {apps} from "@hantera/portal-app";
import {ref} from "vue";

const props = defineProps<{
  hit: apps.standardServices.SearchProduct
}>()

const displayFallbackImage = ref(!props.hit.image);

function onImageError() {
  displayFallbackImage.value = true
}

</script>

<template>
  <div class="hit">
    <div class="image box">
      <img
        :src="props.hit.image"
        @error="onImageError"
        v-if="!displayFallbackImage"
      />
    </div>
    <div class="product-number">
      {{hit.productNumber}}
    </div>
    <div class="description">
      {{hit.description}}
    </div>
  </div>
</template>

<style scoped>

.hit {
  display: grid;
  grid-template-columns: 35px max-content max-content max-content;
  column-gap: 10px;
  cursor: pointer;
  padding: 2px 5px;
}

.image {
  grid-column: 1 / 2;
  grid-row: 1 / 3;
  position: relative;
}

.image img {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.product-number {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
}

.description {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
}

.unit-price, .tax-factor {
  grid-row: 1 / 3;
  text-align: right;
}

</style>